import AOS from "aos";
import "aos/dist/aos.css";

export const initAOS = () => {
  AOS.init({
    duration: 1500,
    once: false,
    easing: "ease-in-out",
  });
};